export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100] as const;

/** A zero page size means the caller has no page size yet, not an infinite number of pages. */
export const getPageCount = (count: number, rowsPerPage: number) =>
  rowsPerPage > 0 ? Math.ceil(count / rowsPerPage) : 0;

/** `1-10 of 32` for a zero-based `page`; `0-0 of 0` with no rows. */
export const formatDisplayedRows = (page: number, rowsPerPage: number, count: number) => {
  if (count === 0) {
    return "0-0 of 0";
  }

  const from = page * rowsPerPage + 1;
  const to = Math.min(count, (page + 1) * rowsPerPage);

  return `${from}-${to} of ${count}`;
};
